import React, { useContext, useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { CarrierGroupsInIds, LovDTO } from '@api/ringil-api.v2';
import * as yup from 'yup';
import { findValidationMessage } from '@utils/validation';
import { ApiContext } from '@api/api';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import useForm from '@hooks/useForm/useForm.tsx';
import { ColWithGap } from '@components/styles.tsx';
import { Field } from '@components/framework/formfield/Field.tsx';

interface ComponentProps {
  visible: boolean;
  onHide: () => void;
  carrierId: string;
  onSuccess: () => void;
}

const AddToCarrierGroupSidebar: React.FC<ComponentProps> = ({ visible, onHide, carrierId, onSuccess }) => {
  const { tr } = useTranslationLgs();
  const { cuLoVCarrierGroups, cuAddCarrierGroupForCarrier } = useContext(ApiContext);
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState<LovDTO[]>(undefined);

  const load = () => {
    cuLoVCarrierGroups(carrierId, data => {
      setGroups(data.groups);
    });
  };

  useEffect(() => {
    if (visible) {
      load();
      form.setFieldValue(form.names.carrierGroupIds, []);
    }
  }, [visible]);

  const schema = yup.object().shape({
    carrierGroupIds: yup.array().min(1).required(),
  });

  const formInitialValues: CarrierGroupsInIds = {
    carrierGroupIds: [],
  };

  const onContinueHandler = (data: CarrierGroupsInIds) => {
    setLoading(true);
    cuAddCarrierGroupForCarrier(
      carrierId,
      data,
      () => {
        setLoading(false);
        onSuccess();
      },
    );
  }

  const form = useForm<CarrierGroupsInIds>(
    schema,
    formInitialValues,
    (d) => onContinueHandler(d),
    false,
    false,
    () => {
    },
    'none',
  );

  useEffect(() => {
    console.log(form.values);
  }, [form.values]);

  return (
    <>
      {/*
        // @ts-ignore*/}
      <RingilSidebar
        heading={tr(`AddToCarrierGroup.addCarriersToGroups`, `Add carriers to groups`)}
        visible={visible}
        onBack={onHide}
        onContinue={() => form.validateAndSend()}
        loading={loading}
      >
        <ColWithGap>
          {groups && groups.length > 0 && (
            <Field
              label={tr(`AddToCarrierGroup.carrierGroupName`, `Carrier group name`)}
              required
              errorMessage={findValidationMessage(form.validationErrors, form.names.carrierGroupIds, tr)}
            >
              <MultiSelect
                display="chip"
                value={form.values.carrierGroupIds}
                options={groups}
                onChange={e => {
                  form.setFieldValue('carrierGroupIds', e.value);
                }}
                optionLabel="name"
                optionValue="id"
                placeholder={tr(`AddToCarrierGroup.selectAGroup`, `Select a group`)}
                filter
              />
            </Field>
          )}

        </ColWithGap>
      </RingilSidebar>
    </>
  );
};

export default AddToCarrierGroupSidebar;
